import { Role } from 'types/enums';

export const getUserRole = (role: Role, isClientOwner: boolean) => {
  // 'client_owner' is not a role anymore on BE side, it is a boolean attribute for 'client_admin' role
  if (role === Role.CLIENT_ADMIN && isClientOwner) {
    return Role.CLIENT_OWNER;
  }

  return role;
}
